export default "__VITE_ASSET__DZbcNYro__"